export default __webpack_public_path__ + "static/media/g-araneta.37ba4a5e.jpg";